import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { MdmCertificateFeatureKey, CertficateReducer } from './certificate.reducer';
import { EffectsModule } from '@ngrx/effects';
import { CertificateEffects } from './certificate.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(MdmCertificateFeatureKey, CertficateReducer),
    EffectsModule.forFeature([CertificateEffects]),
  ],
  providers: [],
})
export class CertificateStoreModule {}
